import IblJsClient from './dist/ibl-web-core-frontend';

export { utils } from './dist/ibl-web-core-frontend';

export default IblJsClient;
